import {
  fetchAPI,
  TASKS_SERVICE_URL,
} from "@coworker/app/src/hooks/API/tasks.service.helper";
import { useQuery } from "@tanstack/react-query";
import { INTERVAL } from "@coworker/app/src/constants/clientTime";
import { Activity } from "../types/activity";
import { FetchApiResponse } from "@coworker/apprestructured/src/shared/types/fetchApiResponseType";

async function fetchTaskActivities(taskId: string) {
  const url = `${TASKS_SERVICE_URL}/v1/task/${taskId}/activities`;
  const { result } = (await fetchAPI("GET", url)) as FetchApiResponse;
  return result as Activity[];
}

export function useTaskActivities(taskId: string) {
  return useQuery<Activity[]>({
    queryKey: ["task", "activities", taskId],
    queryFn: async () => await fetchTaskActivities(taskId),
    staleTime: INTERVAL.HOUR,
    enabled: !!taskId,
  });
}
